import { track } from '@eventbrite/datalayer-library';
import { Avatar } from '@eventbrite/eds-avatar';
import { Icon } from '@eventbrite/eds-icon';
import { CheckChunky } from '@eventbrite/eds-iconography';
import React, { useEffect } from 'react';
import { FeatureFlags } from '../../../../types';
import DefaultImageVariants from '../DefaultImageVariants/DefaultImageVariants';
import './CreatorAvatar.scss';

interface CreatorAvatarProps {
    organizerId: string;
    organizerAvatar?: string;
    featureFlags?: FeatureFlags;
    showBadge?: boolean;
    setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    isMobile?: boolean;
}

export const CreatorAvatar = ({
    organizerId,
    organizerAvatar,
    featureFlags,
    showBadge,
    setIsModalOpen,
}: CreatorAvatarProps) => {
    const enableCreatorDefaultAvatar =
        featureFlags?.enableCreatorDefaultAvatar || false;
    const enableCreatorBadge = featureFlags?.enableCreatorBadge || false;
    const showCreatorBadge = showBadge && enableCreatorBadge;

    useEffect(() => {
        if (showCreatorBadge) {
            track({
                eventName: 'ViewVerificationBadge',
                eventData: {
                    badgeType: 'salesCreatorBadge',
                },
            });
        }
    }, [showCreatorBadge]);

    const trackBadgeClick = () => {
        track({
            eventName: 'ClickVerificationBadge',
            eventData: {
                badgeType: 'salesCreatorBadge',
            },
        });
    };

    const onAvatarClick = () => {
        if (showCreatorBadge) {
            setIsModalOpen?.(true);
            trackBadgeClick();
        }
    };

    return (
        <section
            className={
                showCreatorBadge
                    ? 'organizer-info-avatar-with-badge'
                    : 'organizer-info-avatar'
            }
            data-testid="organizer-info-avatar-test-id"
            onClick={onAvatarClick}
        >
            {organizerAvatar ? (
                <Avatar imageUrl={organizerAvatar} />
            ) : (
                enableCreatorDefaultAvatar && (
                    <div
                        className={
                            showCreatorBadge
                                ? 'organizer-info-avatar-badge'
                                : 'organizer-info-avatar'
                        }
                        data-testid="organizer-info-default-avatar-test-id"
                    >
                        <DefaultImageVariants organizerId={organizerId} />
                    </div>
                )
            )}
            {showCreatorBadge && (
                <div className="organizer-info-badge-tick-icon">
                    <Icon type={<CheckChunky />} />
                </div>
            )}
        </section>
    );
};
